var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    viewBox: "0 0 64.61 64.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4148+64.613L11.1838+64.613C8.92968+64.5369+7.16032+62.6545+7.22377+60.4L7.22377+4.21301C7.16032+1.95854+8.92968+0.0761334+11.1838+1.28675e-05L42.8588+1.28675e-05C43.2132+0.00072504+43.5512+0.149769+43.7908+0.411013L56.9908+14.457C57.2408+14.727+57.3788+15.082+57.3768+15.45L57.3768+60.401C57.4396+62.6559+55.6692+64.538+53.4148+64.613ZM11.1838+2.81301C10.434+2.83803+9.84468+3.46304+9.86377+4.21301L9.86377+60.399C9.84468+61.149+10.434+61.774+11.1838+61.799L53.4148+61.799C54.1648+61.7745+54.7544+61.1492+54.7348+60.399L54.7348+19.664L40.2188+19.664C39.4685+19.6401+38.8786+19.0144+38.8988+18.264L38.8988+2.80902L11.1838+2.81301ZM41.5388+16.856L54.7388+16.856L54.7388+16.034L42.3128+2.80902L41.5388+2.80902L41.5388+16.856Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2998+28.092L16.4618+28.092C15.7186+28.0476+15.1386+27.432+15.1386+26.6875C15.1386+25.943+15.7186+25.3274+16.4618+25.283L32.2998+25.283C33.0429+25.3274+33.6229+25.943+33.6229+26.6875C33.6229+27.432+33.0429+28.0476+32.2998+28.092Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2998+44.947L16.4618+44.947C15.7186+44.9027+15.1386+44.287+15.1386+43.5425C15.1386+42.798+15.7186+42.1824+16.4618+42.138L32.2998+42.138C33.0429+42.1824+33.6229+42.798+33.6229+43.5425C33.6229+44.287+33.0429+44.9027+32.2998+44.947Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1368+36.521L16.4618+36.521C15.718+36.4766+15.1376+35.8605+15.1376+35.1155C15.1376+34.3705+15.718+33.7544+16.4618+33.71L48.1368+33.71C48.8805+33.7544+49.4609+34.3705+49.4609+35.1155C49.4609+35.8605+48.8805+36.4766+48.1368+36.521Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1368+53.376L16.4618+53.376C15.7186+53.3316+15.1386+52.716+15.1386+51.9715C15.1386+51.227+15.7186+50.6113+16.4618+50.567L48.1368+50.567C48.8799+50.6113+49.4599+51.227+49.4599+51.9715C49.4599+52.716+48.8799+53.3316+48.1368+53.376Z",
    opacity: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2188+19.663L16.4618+19.663C15.712+19.6385+15.123+19.0128+15.1438+18.263L15.1438+9.83399C15.1241+9.08457+15.7125+8.45955+16.4618+8.43399L40.2188+8.43399C40.9619+8.47836+41.5419+9.09399+41.5419+9.83849C41.5419+10.583+40.9619+11.1986+40.2188+11.243L17.7818+11.243L17.7818+16.863L40.2188+16.863C40.9619+16.9074+41.5419+17.523+41.5419+18.2675C41.5419+19.012+40.9619+19.6276+40.2188+19.672L40.2188+19.663Z",
    opacity: 1,
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.1322b56dd5f0900312614d043c12d3cc.svg";
export { ForwardRef as ReactComponent };